// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DataService {
   api: any
   data: any
   fire: any
   viewState: ViewStateService
   $window: any
   constructor(api: any, hooksService: any, viewStateService: ViewStateService, $window: any) {
      this.reset = this.reset.bind(this)
      this.api = api
      this.data = {}
      this.viewState = viewStateService
      this.$window = $window
      this.reset()
      this.api.on('update', (data: any, debug: any) => {
         if (!debug) { return this.update(data) }
      })

      hooksService.setHooks(this, 'DataService', ['new', 'update'])
   }

   update(data: any) {
      if (this.data.updateType) { this.data.updateType = null }
      if (data.query && this.viewState.scopeBuilderMode) {
         this.$window.parent.postMessage({params: data.query.query_string }, "*") //`${this.customizerUrl}/settings#SearchScopes`
      }
      if (data.query) {
         this.data.search = data
         return this.fire('new', data)
      } else {
         let fireUpdate = false
         if (data.documents != null) {
            // add updateType for documents; otherwise, the 'end of results' check
            // gets performed on ALL updates (i.e. facet_values, reviews) which can
            // cause the EOR message to display prematurely
            this.data.updateType = "documents"
            this.data.search.documents.push.apply(this.data.search.documents, data.documents)
            fireUpdate = true
         } else {
            if(!this.data.search.documents?.length) {fireUpdate = true}
         }
         this.data.detailDocument = data.detail_documents ? data.detail_documents[0] : null
         if ( this.data.detailDocument && !this.data.updated ) {
            fireUpdate = true
         }
         if (data.reviews != null) {
            fireUpdate = true
            this.data.updateType = "reviews"
            this.data.reviews = {
               id: data.id,
               reviews: data.reviews
            }
         }
         if (data.ai_documents != null) {
            this.data.updateType = "ai"
            this.data.aiDocuments = {
               id: data.id,
               aiDocuments: data.ai_documents
            }
         }
         if (data.facet_values != null) {
            fireUpdate = true
            if (!this.data.facet_values) { this.data.facet_values = {} }
            const facet = data.facet_values[0]
            this.data.facet_values[data.facet] = facet
         }
         this.data.updated = true
         if(fireUpdate) { this.fire('update', data) }
         return
      }
   }

   reset() {
      return this.data.search = {}
   }
}

DataService.$inject = ['apiService', 'hooksService', 'viewStateService', '$window']

angular.module('summonApp.services')
   .service('dataService', DataService)
